export const STORY_POINT_ESTIMATE_BADGE_TEST_ID =
	'issue-field-story-point-estimate-readview-full.ui.story-point-estimate.badge';
export const STORY_POINT_ESTIMATE_TEST_ID =
	'issue-field-story-point-estimate-readview-full.ui.story-point-estimate';
